import { render, staticRenderFns } from "./MyNeofintechNotifications.vue?vue&type=template&id=b98dad02&scoped=true&"
import script from "./MyNeofintechNotifications.vue?vue&type=script&lang=js&"
export * from "./MyNeofintechNotifications.vue?vue&type=script&lang=js&"
import style0 from "./MyNeofintechNotifications.vue?vue&type=style&index=0&id=b98dad02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98dad02",
  null
  
)

export default component.exports